
import { DashboardLayout } from "@/components/layout/DashboardLayout";
import { PageTitle } from "@/components/ui/PageTitle";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Card } from "@/components/ui/card";
import { IncidentDialog } from "@/components/incidents/IncidentDialog";
import { DataTable } from "@/components/ui/data-table";
import { format } from "date-fns";
import { fr } from "date-fns/locale";
import { getProductName } from "@/components/history/ProductUtils";

const Incidents = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  
  const { data: incidents = [], refetch } = useQuery({
    queryKey: ["incidents"],
    queryFn: async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) throw new Error("Non authentifié");

      const { data, error } = await supabase
        .from("stock_incidents")
        .select(`
          *,
          stock_items (
            id,
            data,
            quantity
          )
        `)
        .eq("owner_id", user.id)
        .order("created_at", { ascending: false });

      if (error) throw error;
      return data;
    }
  });

  const columns = [
    {
      id: "date",
      label: "Date",
      cell: (row: any) => format(new Date(row.created_at), "Pp", { locale: fr })
    },
    {
      id: "product",
      label: "Produit",
      cell: (row: any) => getProductName(row.stock_items)
    },
    {
      id: "quantity",
      label: "Quantité",
      cell: (row: any) => row.quantity
    },
    {
      id: "reason",
      label: "Motif",
      cell: (row: any) => row.reason
    },
    {
      id: "status",
      label: "Statut",
      cell: (row: any) => row.status === "pending" ? "En attente" : "Traité"
    }
  ];

  return (
    <DashboardLayout userType="owner">
      <div className="container mx-auto px-0 py-6">
        <PageTitle title="Incidents" subtitle="Gestion des incidents du stock" />

        <div className="mb-6">
          <Button onClick={() => setIsDialogOpen(true)}>
            <Plus className="w-4 h-4 mr-2" />
            Signaler un incident
          </Button>
        </div>

        <Card className="p-6 px-0 py-[14px] my-0 mx-0">
          <DataTable columns={columns} data={incidents} />
        </Card>

        <IncidentDialog 
          open={isDialogOpen} 
          onOpenChange={setIsDialogOpen} 
          onSuccess={() => {
            setIsDialogOpen(false);
            refetch();
            toast.success("Incident signalé avec succès");
          }} 
        />
      </div>
    </DashboardLayout>
  );
};

export default Incidents;
